import client from "./client";

export async function registerUser(values) {
  try {
    let { data } = await client.post(
      `/register`,
      // { ...values },
      values,
      {
        "Content-Type": "multipart/form-data",
      }
    );
    return data;
  } catch (err) {
    console.error(err);
  }
}
